// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Default = require("../Data.Default/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Foreign_Object = require("../Foreign.Object/index.js");
var GistId = function (x) {
    return x;
};
var GistFiles = function (x) {
    return x;
};
var Gist = function (x) {
    return x;
};
var showGistId = new Data_Show.Show(function (v) {
    return v;
});
var newtypeGistId = new Data_Newtype.Newtype(function (n) {
    return n;
}, GistId);
var eqGistId = new Data_Eq.Eq(function (x) {
    return function (y) {
        return x === y;
    };
});
var encodeJsonGistId = Data_Argonaut_Encode_Class.encodeJsonJString;
var defaultGistId = new Data_Default.Default("d1e270048b1f276438ee31ca345862aa");
var decodeJsonGistId = Data_Argonaut_Decode_Class.decodeJsonString;
var decodeJsonGistFiles = new Data_Argonaut_Decode_Class.DecodeJson(function (json) {
    return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeForeignObject(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonString)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonString)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonString)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonString)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonInt)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonBoolean)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonString)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
        return "type";
    }))()())(new Data_Symbol.IsSymbol(function () {
        return "truncated";
    }))()())(new Data_Symbol.IsSymbol(function () {
        return "size";
    }))()())(new Data_Symbol.IsSymbol(function () {
        return "raw_url";
    }))()())(new Data_Symbol.IsSymbol(function () {
        return "language";
    }))()())(new Data_Symbol.IsSymbol(function () {
        return "filename";
    }))()())(new Data_Symbol.IsSymbol(function () {
        return "content";
    }))()())()))(json))(function (v) {
        return Control_Applicative.pure(Data_Either.applicativeEither)(GistFiles(Data_Map_Internal.fromFoldableWithIndex(Data_Ord.ordString)(Foreign_Object.foldableWithIndexObject)(v)));
    });
});
var decodeJsonGist = Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonString)(Data_Argonaut_Decode_Class.gDecodeJsonCons(decodeJsonGistFiles)(Data_Argonaut_Decode_Class.gDecodeJsonCons(decodeJsonGistId)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonBoolean)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonString)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
    return "url";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "public";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "id";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "files";
}))()())(new Data_Symbol.IsSymbol(function () {
    return "description";
}))()())();
module.exports = {
    GistFiles: GistFiles,
    Gist: Gist,
    GistId: GistId,
    decodeJsonGistFiles: decodeJsonGistFiles,
    decodeJsonGist: decodeJsonGist,
    showGistId: showGistId,
    newtypeGistId: newtypeGistId,
    eqGistId: eqGistId,
    decodeJsonGistId: decodeJsonGistId,
    encodeJsonGistId: encodeJsonGistId,
    defaultGistId: defaultGistId
};
